export default __webpack_public_path__ + "static/media/feather_plus_white.455bbe06.svg";